// @flow

import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  quote: string,
  className?: string,
  client: {
    name: string,
    logo:
      | React.Element<'img'>
      | React.Element<typeof GatsbyImage>
      | React.Element<typeof StaticImage>,
    description: string,
  },
|}

export default function QuoteAlternate({ client, quote, className }: Props) {
  return (
    <Root className={className}>
      <QuoteStyled>"{quote}"</QuoteStyled>
      <text.P2 color={colors.pink}>{client.name}</text.P2>
      <text.P2 color={colors.pink}>{client.description}</text.P2>
      {client.logo}
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  margin-bottom: 70px;
  position: relative;
  padding: 40px 40px 70px;
  background: ${colors.almostWhite};
  ${media.mq[1]} {
    margin-bottom: 120px;
    padding: 40px 60px 70px;
  }
  ${media.mq[2]} {
    max-width: 950px;
    &:nth-of-type(even) {
      margin-left: auto;
    }
  }
  .gatsby-image-wrapper {
    width: 100%;
    max-width: 95px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    ${media.mq[2]} {
      height: 235px;
    }
  }
`

const QuoteStyled = styled(text.H3)`
  margin-bottom: 20px;
  color: ${colors.darkPurple};
  line-height: 1.5;
`
